import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import './TourNav.css';

export default function TourNav() {
  const [isSticky, setIsSticky] = useState(false);
 const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Trigger the navbar visibility after 300px of scrolling
      if (window.scrollY > 15) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isSticky) return null;
 
  
  return (
    <section className="sticky-tour-nav-wrapper">
      <div className="sticky-tour-nav-container">
        <ul className="sticky-tour-nav-list">
          <li className="sticky-tour-nav-item">
            <Link 
              to="overview" 
              smooth={true} 
              duration={500} 
              offset={-60}
              className="sticky-tour-nav-link"
              activeClass="sticky-tour-nav-link-active"
              spy={false}
            >
              Overview
            </Link>
          </li>
      <li className="sticky-tour-nav-item">
            <Link 
              to="itinerary" 
              smooth={true} 
              duration={500} 
              offset={-60} 
              className="sticky-tour-nav-link"
              activeClass="sticky-tour-nav-link-active"
            spy={false}
            >
              Itinerary
            </Link>
          </li>
          <li className="sticky-tour-nav-item">
            <Link 
              to="included" 
              smooth={true} 
              duration={500} 
              offset={-60}
              className="sticky-tour-nav-link"
              activeClass="sticky-tour-nav-link-active"
              spy={false}
            >
              Included
            </Link>
          </li>
          <li className="sticky-tour-nav-item">
            <Link 
              to="price" 
              smooth={true} 
              duration={500} 
              offset={-60}
              className="sticky-tour-nav-link"
              activeClass="sticky-tour-nav-link-active"
              spy={false}
            >
              Price
            </Link>
          </li>
          
        </ul>
      </div>
    </section>
  );
}